import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { Location } from '@angular/common';

import { AttachementsPluginService } from './attachements-plugin.service';
import { BaseModalPageComponent } from '../../base-modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';

@Component({
    selector: 'attachement-delete',
    templateUrl: './attachement-delete.component.html',
    standalone: false
})
export class AttachementDeletePageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  pointId: string;
  pluginId: string;
  assetId: string;
  public plugin: any;
  processing: boolean;
  @ViewChild('deleteConfirm', { static: true })
  deleteConfirm: ConfirmComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private service: AttachementsPluginService,
    location: Location,
    private cdf: ChangeDetectorRef
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;

      const pointId = params['pointId'];
      if (pointId == null) this.router.navigate([this.inspectionsRoute, this.inspectionId]);

      this.pointId = pointId;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();

      this.pluginId = pluginId;

      const assetId = params['assetId'];
      if (assetId == null) this.goToBack();

      this.assetId = assetId;

      this.initData();
    });
  }

  deleteFile(e: any) {
    this.processing = true;
    this.service.deleteFile(this.inspectionId, this.pointId, this.pluginId, this.assetId).subscribe((data) => {
      this.processing = false;
      this.goToBack();
    });
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
  }

  initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.cdf.detectChanges();
      this.deleteConfirm.open();
    });
  }
}
